define('modules/common/interceptor',[], function() {
    "use strict";
    var Provider = function($httpProvider) {
        $httpProvider.interceptors.push(['$q','$injector',function($q,$injector) {
            return {
               'responseError': function (rejection) {
                    var $state = $injector.get('$state');
                    var Studio = $injector.get('Studio');
                    if(rejection.status === 401 && $state.current.name !== 'login' && $state.current.name !== 'loginStudio') {
                        $state.go('loginStudio',{aliasStudio:Studio.getAlias()});
                    }
                    return $q.reject(rejection);
                }
            };
        }]);
    };
    return ["$httpProvider", Provider];
});
